import React, { useState, useEffect } from 'react';
import Panel from 'Components/Panel/Panel'
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import PanelListDefault from 'Components/PanelListDefault/PanelListDefault';
import ApplyAttributes from 'Components/ApplyAttributes/ApplyAttributes';
import OptionsDataByAttributePath from 'Components/Options/optionsData/OptionsDataByAttributePath';
import AutomaticallyListedAttributes from 'Components/AutomaticallyListedAttributes/AutomaticallyListedAttributes';
import ResetVariables from 'Components/ResetVariables/ResetVariables';


const Operations = ({
    onUpdateOperationIdSelected,
    onUpdateReloadListOperation,
    operationIdSelected,
    supplierIdSelected,
    operationsListFilter,
    insertingForced=false
}) => {
    const [idOperation, setIdOperation] = useState(null);
    const [dsOperation, setDsOperation] = useState(null);
    const [machineId, setMachineId] = useState(null);
    const [classificationId, setClassificationId] = useState(null);
    const [supplierId, setSupplierId] = useState(null);
    const [isActive, setIsActive] = useState('S');
    const [username, setUsername] = useState(null);
    const [dtUpdate, setDtUpdate] = useState(null);

    const [inserting, setInserting] = useState(false);
    const [updating, setUpdating] = useState(false);

    const [loadingOperationPanel, setLoadingOperationPanel] = useState(null);
    const [recordsOperationGrid, setRecordsOperationGrid] = useState(null);
    const [attributesDetailOperationPanel, setAttributesDetailOperationPanel] = useState(null);
    const [machineList, setMachineList] = useState(null);
    const [classificationList, setClassificationList] = useState(null);
    const [supplierList, setSupplierList] = useState(null);

    const itemsMachineOptions = OptionsDataByAttributePath(machineList, ['description'], null, true);
    const itemsClassificationOptions = OptionsDataByAttributePath(classificationList, ['description'], null, true);
    const itemsSupplierOptions = OptionsDataByAttributePath(supplierList, ['description'], null, true);

    const readOnlyAttributes = insertingForced ? false : !(inserting || updating);

    const attributeList = [
        { name: "id", value: idOperation, setter: setIdOperation, allowsMultipleRecordsSelected: true },
        { name: "dsOperation", value: dsOperation, setter: setDsOperation, minGridWidth: '400px', maxGridWidth: '400px', whiteSpace: 'normal', style: { height: '80px' } },
        { name: "machineId", value: machineId, setter: setMachineId, comboboxOptions: itemsMachineOptions },
        { name: "classificationId", value: classificationId, setter: setClassificationId, comboboxOptions: itemsClassificationOptions },
        { name: "supplierId", value: supplierId, setter: setSupplierId, comboboxOptions: itemsSupplierOptions, readOnly: true },
        {
            name: "isActive",
            value: isActive,
            setter: setIsActive,
            resetValue: 'S',
            checks: [
                { field: 'isActive', condition: 'VALUE_EQUALS', arrayValue: ['S'] }
            ]
        },
        { name: "username", value: username, setter: setUsername },
        { name: "dtUpdate", value: dtUpdate, setter: setDtUpdate }
    ];

    useEffect(() => {
        if (operationsListFilter && operationsListFilter.length > 0) {
            setRecordsOperationGrid(operationsListFilter);
        }
    }, [operationsListFilter]);

    useEffect(() => {
        onUpdateOperationIdSelected([])
    }, [supplierIdSelected]);

    useEffect(() => {
        if ((!operationIdSelected || operationIdSelected.length != 1) && updating) {
            setUpdating(false)
        }

        if (!operationIdSelected || operationIdSelected.length > 1) {
            onUpdateOperationIdSelected([])
        }
    }, [inserting, updating]);


    useEffect(() => {
        if (operationIdSelected && operationIdSelected.length === 1) {
            fetchDataDetail(operationIdSelected[0])
        } else {
            fetchDataDetail(null)
        }
    }, [operationIdSelected])

    useEffect(() => {
        const onReady = async () => {
            // listas fixas: carregam uma vez ao abrir a tela, em paralelo
            await Promise.all([callToSetMachineList(), callToSetClassificationList(), callToSetSupplierList()])
        };

        onReady();
    }, [])

    async function callToSetMachineList() {
        const machineList = await ExecuteAxios.api('get', `/machine/get-active-machine-list/`)
        setMachineList(machineList)
    }

    async function callToSetClassificationList() {
        const classificationList = await ExecuteAxios.api('get', `/classification/get-active-classification-list/`);
        setClassificationList(classificationList)
    }

    async function callToSetSupplierList() {
        const supplierList = await ExecuteAxios.api('get', `/supplier/get-active-supplier-list/`);
        setSupplierList(supplierList);
    }

    const operationPanelStyle = {
        display: 'flex',
        flexDirection: 'column',
        height: '80%'
    };

    const fetchDataDetail = async (operationIdSelected) => {
        const parameters = { id: operationIdSelected ? operationIdSelected : 0 }
        const operation = await ExecuteAxios.api('get', `/operation/get-operation-detail/`, { params: parameters })
        if (operation) {
            setAttributesDetailOperationPanel(operation)
            ApplyAttributes.applyAttributes(operation, attributeList)
        }

        if (!operationIdSelected || operationIdSelected.length === 0) {
            ResetVariables.resetVariables(attributeList);
        }
    };

    const getOperationPanelListOrDetail = () => {
        if (readOnlyAttributes) {
            return (
                <PanelListDefault
                    onUpdateIdSelected={onUpdateOperationIdSelected}
                    idsSelected={operationIdSelected}
                    data={recordsOperationGrid}
                    attributeList={attributeList}
                />
            )
        } else {
            return (
                <AutomaticallyListedAttributes
                    list={attributesDetailOperationPanel}
                    attributeList={attributeList}
                    readOnlyAttributes={readOnlyAttributes}
                />
            )
        }
    }

    async function postOperation() {
        try {
            setLoadingOperationPanel(true)
            const response = await ExecuteAxios.api('post', `/operation/`, {
                dsOperation: dsOperation,
                machineId: machineId,
                classificationId: classificationId,
                supplierId: supplierIdSelected[0],
                isActive: isActive
            });

            if (response) {
                onUpdateOperationIdSelected([])
                onUpdateReloadListOperation(true)

                if (insertingForced) { 
                    setDsOperation(null)
                    setClassificationId(null)
                    setMachineId(null)
                }
            }

            return response;
        } finally {
            setLoadingOperationPanel(false)
        }
    }

    async function putOperation() {
        try {
            setLoadingOperationPanel(true)
            const response = await ExecuteAxios.api('put', `/operation/`, {
                id: idOperation,
                dsOperation: dsOperation,
                machineId: machineId,
                supplierId: supplierIdSelected[0],
                classificationId: classificationId,
                isActive: isActive
            });

            if (response) {
                onUpdateReloadListOperation(true)
            }

            return response;
        } finally {
            setLoadingOperationPanel(false)
        }
    }

    async function deleteOperationsIdsSelecteds(recordsSelected) {
        try {
            setLoadingOperationPanel(true)
            const parameters = {
                idsList: recordsSelected.join(",")
            };
            const response = await ExecuteAxios.api('delete', `/operation/`, { params: parameters });

            if (response) {
                onUpdateOperationIdSelected([]);
                ResetVariables.resetVariables(attributeList)
                onUpdateReloadListOperation(true)
            }
            return response
        } finally {
            setLoadingOperationPanel(false)

        }
    }

    return (
        <LoadingIndicator loaded={!loadingOperationPanel}>
            <Panel
                style={operationPanelStyle}
                titlePage={'Operações'}
                setUpdating={setUpdating}
                setInserting={setInserting}
                inserting={inserting || insertingForced}
                updating={updating}
                enableEdit={true}
                enableCancelButton={!insertingForced}
                canEdit={operationIdSelected && operationIdSelected.length === 1}
                putFunction={putOperation}
                enableNewRecord={true}
                canNewRecord={supplierIdSelected && supplierIdSelected.length === 1}
                postFunction={postOperation}
                deleteFunction={deleteOperationsIdsSelecteds}
                canDelete={operationIdSelected && operationIdSelected.length > 0}
                enableDelete={operationIdSelected && operationIdSelected.length > 0}
                canViewCRUD={true}
                readOnly={false}
                recordsSelected={operationIdSelected}
                resetVariables={() => { ResetVariables.resetVariables(attributeList) }}
                dataListedAttributes={attributesDetailOperationPanel}
                attributeList={attributeList}
                onUpdateIdSelected={onUpdateOperationIdSelected}
            >
                {getOperationPanelListOrDetail()}
            </Panel>
        </LoadingIndicator>
    );

}
export default Operations;